import { useRoutes } from 'react-router';
import Layout from '../Components/Layout';
import { ForgetPassword } from '../Pages/Forget_Password';
import { ResetPassword } from '../Pages/Forget_Password/ResetPassword';
import { Login } from '../Pages/Login';
import { NotFound } from '../Pages/NotFound';
import Register from '../Pages/Register';
import { Users } from '../Pages/Users';
import { FeedBack } from '../Pages/FeedBack';
import ViewDetails from '../Pages/Users/ViewDetails';
import { PrivateRouter } from './PrivateRouter';
import { AuthRouter } from './AuthRouter';
import ViewPractionerDetails from '../Pages/Users/ViewPractionerDetails';
import { Programs } from '../Pages/Programs';
import GridViewIcon from '@mui/icons-material/GridView';
import PersonIcon from '@mui/icons-material/Person';
import CommentTwoToneIcon from '@mui/icons-material/CommentTwoTone';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PolicyIcon from '@mui/icons-material/Policy';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import SettingsIcon from '@mui/icons-material/Settings';
import CreateProgram from '../Pages/Programs/CreateProgram';
import { Bulletin } from '../Pages/Bulletin';
import CreateBulletin from '../Pages/Bulletin/CreateBulletin';
import { VerifyAccount } from '../Pages/Email verification';
import { Explore } from '../Pages/Explore';
import CreateContent from '../Pages/Explore/CreateContent';
import FooterPage from '../Pages/Footer_Page';
import { useSelector } from 'react-redux';
import { Category } from '../Pages/Explore/Category';
import { useState } from 'react';
import Settings from '../Pages/Settings';
import MobileSideFooterPage from '../Pages/Footer_Page/MobileSideFooterPages';
import Overview from '../Pages/Overview';
import { Report } from '../Pages/Report';
import UserPermission from '../Pages/Settings/UserPermission';
import { useEffect } from 'react';
import ForgotMsg from '../Pages/Forget_Password/ForgotMsg';
import {Dashboard} from '../Pages/Dashboard';
import ExplorePreview from '../Pages/Explore/ExplorePreview';
import BulletinPreview from '../Pages/Bulletin/BulletinPreview';
//getting user data from localstorage
const userData = JSON.parse(localStorage.getItem('userData'));
export const adminRoutes = [
  {
    path: '/',
    element: (
      <AuthRouter>
        <Dashboard />
      </AuthRouter>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthRouter>
        <Login />
      </AuthRouter>
    ),
  },
  {
    path: `/invite-accepted/:token/:value`,
    element: <VerifyAccount />,
  },

  {
    path: "/register",
    element: (
      <AuthRouter>
        <Register />
      </AuthRouter>
    ),
  },
  {
    path: "/forget-password",
    element: <ForgetPassword />,
  },
  {
    path: "/reset-password/:token/:value",
    element: <ResetPassword />,
  },
  {
    path: "/forgot-msg",
    element: <ForgotMsg />,
  },
  {
    path: `/privacy-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/faq`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/terms-and-conditions`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/cookie-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: "/dashboard",
    name: "OVERVIEW",
    icon: <GridViewIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Overview />,
      },
    ],
  },
  {
    path: "/report",
    name: "REPORT",
    icon: <TextSnippetIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Report />,
      },
    ],
  },
  {
    path: "/users",
    name: "USERS",
    icon: <PersonIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Users />,
      },
      {
        path: "/users/overview/:id",
        element: <ViewDetails />,
      },
      {
        path: "/users/practioners/:id",
        element: <ViewPractionerDetails />,
      },
    ],
  },
  {
    path: "/programs",
    name: "PROGRAMS",
    icon: <EventNoteIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Programs />,
      },
      {
        path: "/programs/create",
        element: <CreateProgram />,
      },
    ],
  },
  {
    path: "/explore",
    name: "EXPLORE",
    icon: <PolicyIcon />,
    isSideKey: "true",
    isSubmenu: "true",
    subMenu: [
      {
        name: "Category",
        path: "/explore/category",
      },
      {
        name: "Content",
        path: "/explore",
      },
    ],
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Explore />,
      },
      {
        path: "/explore/create-content",
        element: <CreateContent />,
      },
      {
        path: "/explore/create-content/preview",
        element: <ExplorePreview />,
      },
      {
        path: "/explore/category",
        element: <Category />,
      },
    ],
  },
  {
    path: "/bulletin",
    name: "BULLETIN",
    icon: <NewspaperIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Bulletin />,
      },
      {
        path: "/bulletin/create",
        element: <CreateBulletin />,
      },
      {
        path: "/bulletin/create/preview",
        element: <BulletinPreview />,
      },
    ],
  },
  {
    path: "/footer-pages",
    name: "FOOTER PAGES",
    icon: <ArrowCircleDownIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <FooterPage />,
      },
    ],
  },
  {
    path: "/feedback",
    name: "FEEDBACK",
    icon: <CommentTwoToneIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <FeedBack />,
      },
    ],
  },
  {
    path: "/settings",
    name: "SETTINGS",
    icon: <SettingsIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Settings />,
      },
      {
        path: "/settings/userPermission",
        element: <UserPermission />,
      },
    ],
  },
  {
    path: "*",
    element: (
      <PrivateRouter>
        <NotFound />
      </PrivateRouter>
    ),
  },
];
export const researcherRoutes = [
  {
    path: '/',
    element: (
      <AuthRouter>
        <Dashboard />
      </AuthRouter>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthRouter>
        <Login />
      </AuthRouter>
    ),
  },
  {
    path: `/invite-accepted/:token/:value`,
    element: <VerifyAccount />,
  },

  {
    path: "/register",
    element: (
      <AuthRouter>
        <Register />
      </AuthRouter>
    ),
  },
  {
    path: "/forget-password",
    element: <ForgetPassword />,
  },
  {
    path: "/reset-password/:token/:value",
    element: <ResetPassword />,
  },
  {
    path: "/forgot-msg",
    element: <ForgotMsg />,
  },
  {
    path: `/privacy-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/faq`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/terms-and-conditions`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/cookie-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: "/dashboard",
    name: "OVERVIEW",
    icon: <GridViewIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Overview />,
      },
    ],
  },
  {
    path: "/report",
    name: "REPORT",
    icon: <TextSnippetIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Report />,
      },
    ],
  },
  {
    path: "/users",
    name: "USERS",
    icon: <PersonIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Users />,
      },
      {
        path: "/users/overview/:id",
        element: <ViewDetails />,
      },
      {
        path: "/users/practioners/:id",
        element: <ViewPractionerDetails />,
      },
    ],
  },
  {
    path: "/feedback",
    name: "FEEDBACK",
    icon: <CommentTwoToneIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <FeedBack />,
      },
    ],
  },
  {
    path: "*",
    element: (
      <PrivateRouter>
        <NotFound />
      </PrivateRouter>
    ),
  },
];

//declare doctor routes
export const doctorRoutes = [
  {
    path: `/invite-accepted/:token/:value`,
    element: <VerifyAccount />,
  },
  {
    path: '/',
    element: (
      <AuthRouter>
        <Dashboard />
      </AuthRouter>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthRouter>
        <Login />
      </AuthRouter>
    ),
  },
  {
    path: "/register",
    element: (
      <AuthRouter>
        <Register />
      </AuthRouter>
    ),
  },
  {
    path: '/practitioners-dashboard',
    element: <Dashboard />,
  },
  {
    path: '/forget-password',
    element: <ForgetPassword />,
  },
  {
    path: "/reset-password/:token/:value",
    element: <ResetPassword />,
  },
  {
    path: "/forgot-msg",
    element: <ForgotMsg />,
  },
  {
    path: `/account-verified/:token`,
    element: <VerifyAccount />,
  },

  {
    path: `/privacy-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/faq`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/terms-and-conditions`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/cookie-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: "/dashboard",
    name: "OVERVIEW",
    icon: <GridViewIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Overview />,
      },
    ],
  },
  {
    path: "/report",
    name: "REPORT",
    icon: <TextSnippetIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Report />,
      },
    ],
  },
  {
    path: "/users",
    name: "USERS",
    icon: <PersonIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Users />,
      },
      {
        path: "/users/overview/:id",
        element: <ViewDetails />,
      },
      {
        path: "/users/practioners/:id",
        element: <ViewPractionerDetails />,
      },
    ],
  },
  {
    path: "*",
    element: (
      <PrivateRouter>
        <NotFound />
      </PrivateRouter>
    ),
  },
];

//declare doctor as editor routes
export const doctorEditorRoutes = [
  {
    path: `/invite-accepted/:token/:value`,
    element: <VerifyAccount />,
  },
  {
    path: '/',
    element: (
      <AuthRouter>
        <Dashboard />
      </AuthRouter>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthRouter>
        <Login />
      </AuthRouter>
    ),
  },
  {
    path: "/register",
    element: (
      <AuthRouter>
        <Register />
      </AuthRouter>
    ),
  },

  {
    path: "/forget-password",
    element: <ForgetPassword />,
  },
  {
    path: "/reset-password/:token/:value",
    element: <ResetPassword />,
  },
  {
    path: "/forgot-msg",
    element: <ForgotMsg />,
  },
  {
    path: `/account-verified/:token`,
    element: <VerifyAccount />,
  },

  {
    path: `/privacy-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/faq`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/terms-and-conditions`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/cookie-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: "/dashboard",
    name: "OVERVIEW",
    icon: <GridViewIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Overview />,
      },
    ],
  },
  {
    path: "/report",
    name: "REPORT",
    icon: <TextSnippetIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Report />,
      },
    ],
  },
  {
    path: "/users",
    name: "USERS",
    icon: <PersonIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Users />,
      },
      {
        path: "/users/overview/:id",
        element: <ViewDetails />,
      },
      {
        path: "/users/practioners/:id",
        element: <ViewPractionerDetails />,
      },
    ],
  },
  {
    path: "/programs",
    name: "PROGRAMS",
    icon: <EventNoteIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Programs />,
      },
      {
        path: "/programs/create",
        element: <CreateProgram />,
      },
    ],
  },
  {
    path: "*",
    element: (
      <PrivateRouter>
        <NotFound />
      </PrivateRouter>
    ),
  },
];

//declare editor routes
export const editorRoutes = [
  {
    path: `/invite-accepted/:token/:value`,
    element: <VerifyAccount />,
  },
  {
    path: '/',
    element: (
      <AuthRouter>
        <Dashboard />
      </AuthRouter>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthRouter>
        <Login />
      </AuthRouter>
    ),
  },
  {
    path: "/register",
    element: (
      <AuthRouter>
        <Register />
      </AuthRouter>
    ),
  },
  {
    path: "/forget-password",
    element: <ForgetPassword />,
  },
  {
    path: "/reset-password/:token/:value",
    element: <ResetPassword />,
  },
  {
    path: "/forgot-msg",
    element: <ForgotMsg />,
  },
  {
    path: `/account-verified/:token`,
    element: <VerifyAccount />,
  },
  {
    path: "/programs",
    name: "PROGRAMS",
    icon: <EventNoteIcon />,
    isSideKey: "true",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      {
        index: true,
        element: <Programs />,
      },
      {
        path: "/programs/create",
        element: <CreateProgram />,
      },
    ],
  },
  {
    path: `/privacy-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/faq`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/terms-and-conditions`,
    element: <MobileSideFooterPage />,
  },
  {
    path: `/cookie-policy`,
    element: <MobileSideFooterPage />,
  },
  {
    path: "*",
    element: (
      <PrivateRouter>
        <NotFound />
      </PrivateRouter>
    ),
  },
];

//set admin routes using useRoutes
const AdminRoutes = () => {
  const Routes = useRoutes(adminRoutes);
  return Routes;
};

const ResearcherRoutes = () => {
  const Routes = useRoutes(researcherRoutes);
  return Routes;
};

//set doctor routes using useRoutes
const DoctorRoutes = () => {
  const Routes = useRoutes(doctorRoutes);
  return Routes;
};

//set editor routes using useRoutes
const EditorRoutes = () => {
  const Routes = useRoutes(editorRoutes);
  return Routes;
};

//set doctor as editor routes using useRoutes
const DoctorEditorRoutes = () => {
  const Routes = useRoutes(doctorEditorRoutes);
  return Routes;
};

const Routes = () => {
  //getting user data
  const { user } = useSelector((state) => state?.Auth);

  //check user role and set routes based on user role
  //check reducers data (user) because first time user login this page not getting data from localstorage
  return user?.role === "admin" || userData?.role === "admin" ? (
    <AdminRoutes />
  ) : (user?.role === "doctor" || userData?.role === "doctor") &&
    (user?.is_editor === false || userData?.is_editor === false) ? (
    <DoctorRoutes />
  ) : user?.role === "doctor" ||
    (userData?.role === "doctor" &&
      (user?.is_editor === true || userData?.is_editor === true)) ? (
    <DoctorEditorRoutes />
  ) :  user?.role === "researcher" || userData?.role === "researcher" ? (
    <ResearcherRoutes />
  ) :(
    <EditorRoutes />
  );
};

export default Routes;
